import React from 'react'
import Accounting from '../components/Accounting'

const AccountingPage = () => (
  <div style={{ marginTop: 40 }}>
    <Accounting />
  </div>
)

export default AccountingPage
